import { IconInfoCircle } from "@tabler/icons-react";
import { useEffect } from "react";

import * as olvy from "~/components/info-button/olvy";
import { ActionIcon, Tooltip } from "~/ui";

export const InfoButton = () => {
  useEffect(() => {
    olvy.init();
  }, []);

  return (
    <Tooltip label="Click here to see what's new" position="left" withArrow>
      <ActionIcon aria-label="What's new" size={44} radius="sm" id="olvy-whats-new" color="gray">
        <IconInfoCircle size={30} />
      </ActionIcon>
    </Tooltip>
  );
};
